(() => {
  if (window.ktCurrencySelectorReady) return;
  window.ktCurrencySelectorReady = true;
  const dialog = document.getElementById('KtCurrencyDialog');
  if (!dialog) return;
  const form = dialog.querySelector('form');
  const search = dialog.querySelector('input[type="search"]');
  const list = dialog.querySelector('.kt-currency-options');
  const empty = dialog.querySelector('.kt-currency-empty');
  const others = Array.from(list.querySelectorAll('[data-priority="false"]'));
  others.sort((a,b) => a.dataset.currency.localeCompare(b.dataset.currency) || a.textContent.trim().localeCompare(b.textContent.trim()));
  others.forEach(option => list.append(option));
  const options = Array.from(list.querySelectorAll('[name="country_code"]'));
  let opener;
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase().trim();
  const filter = () => {
    const terms = normalize(search.value).split(/\s+/).filter(Boolean);
    dialog.toggleAttribute('data-filtering', terms.length > 0);
    let count = 0;
    options.forEach(option => {option.hidden = !terms.every(term=>normalize(option.dataset.search).includes(term)); if(!option.hidden) count++;});
    empty.hidden = count > 0;
  };
  const close = () => dialog.close();
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-kt-currency-open]');
    if (!button) return;
    opener = button;
    const rect = button.getBoundingClientRect();
    dialog.style.setProperty('--kt-currency-top', `${Math.max(12,Math.min(rect.bottom+14,window.innerHeight-470))}px`);
    dialog.style.setProperty('--kt-currency-left', `${Math.max(12,Math.min(rect.right-328,window.innerWidth-340))}px`);
    search.value = '';
    filter();
    dialog.showModal();
    button.setAttribute('aria-expanded','true');
    search.focus({preventScroll:true});
  });
  dialog.querySelector('[data-kt-currency-close]').addEventListener('click',close);
  dialog.addEventListener('click',event=> {if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();}});
  dialog.addEventListener('close',()=> {document.querySelectorAll('[data-kt-currency-open]').forEach(b=>b.setAttribute('aria-expanded','false'));opener?.focus({preventScroll:true});});
  search.addEventListener('input', filter);
  dialog.addEventListener('keydown', event => {
    const inSearch = event.target===search;
    if (inSearch && event.key==='Enter') {event.preventDefault();return;}
    const arrow = ['ArrowUp','ArrowDown'].includes(event.key);
    const boundary = !inSearch && ['Home','End'].includes(event.key);
    if ((!arrow&&!boundary)||(!inSearch&&!options.includes(event.target))) return;
    event.preventDefault();
    const visible = options.filter(o=>!o.hidden);
    if (!visible.length) return;
    const current = visible.indexOf(event.target);
    let next;
    if(event.key==='Home')next=visible[0];
    else if(event.key==='End')next=visible.at(-1);
    else if(inSearch)next=event.key==='ArrowDown'?visible[0]:visible.at(-1);
    else if(event.key==='ArrowUp')next=current>0?visible[current-1]:search;
    else next=visible[Math.min(current+1,visible.length-1)];
    next.focus();
  });
  form.addEventListener('submit',event=> {if(!event.submitter?.matches('[name="country_code"]'))event.preventDefault();});
})();
